import React from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import { BillingHistory } from "components/settings/billing-history";
import {
  fetchBillingHistoryAction,
  setPaginationLimitAction,
  nextPageAction,
  previousPageAction
} from "actions/account-settings-actions";
import { Loading } from "components/common/loading";

class BillingHistoryPage extends React.Component {
  componentWillMount() {
    this.props.init(this.props.accountId);
  }

  render() {
    if (this.props.isBillingHistoryLoading) {
      return <Loading />;
    }
    if (this.props.vip) {
      return browserHistory.push("/");
    }
    return (
      <BillingHistory { ...this.props } />
    );
  }
}

BillingHistoryPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  init: PropTypes.func.isRequired,
  isBillingHistoryLoading: PropTypes.bool.isRequired,
  vip: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  displayInvoices: state.accountSettings.pagination.displayInvoices,
  invoices: state.accountSettings.invoices,
  isBillingHistoryLoading: state.accountSettings.isBillingHistoryLoading,
  pagination: state.accountSettings.pagination,
  vip: state.accountSettings.vip
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(fetchBillingHistoryAction(accountId)),
  onNextPage: () => dispatch(nextPageAction()),
  onPreviousPage: () => dispatch(previousPageAction()),
  onChangeLimit: (limit) => dispatch(setPaginationLimitAction(limit))
});

export const BillingHistoryContainer = connect(mapStateToProps, mapDispatchToProps)(BillingHistoryPage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/billing-history-container.jsx